import { combineReducers } from 'redux';
import {
    MyAccountSettingFetchSuccessActionType,
    MyAccountSettingFetchRequestActionType,
    MyAccountSettingFetchFailureActionType,
} from './myAccountSettingAction';
import { ActionType } from 'store/ActionType';
import { MyAccountSetting } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

const setting = (
    state: Nullable<MyAccountSetting> = null,
    action: ActionType,
) => {
    switch (action.type) {
        case MyAccountSettingFetchSuccessActionType: {
            return action.payload;
        }
        default: {
            return state;
        }
    }
};

const isLoading = (state = false, action: ActionType) => {
    switch (action.type) {
        case MyAccountSettingFetchRequestActionType: {
            return true;
        }
        case MyAccountSettingFetchFailureActionType:
        case MyAccountSettingFetchSuccessActionType: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    setting,
    isLoading,
});
